import { render, staticRenderFns } from "./Recusar.vue?vue&type=template&id=49bcab42&lang=pug&"
import script from "./Recusar.vue?vue&type=script&lang=js&"
export * from "./Recusar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports